import moment from 'moment';

export default class parser {
  static currency = text => {
    let num = parseFloat(text);
    return (
      '$' + num
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    );
  }

  static date = text => {
    if(!text) { return ''; }
    if(typeof text === 'object'){ return moment(text).format('DD/MM/YYYY'); }
    return !text.startsWith('0001-01-01') ? moment(text).format('DD/MM/YYYY') : ''
  }

  static datetime = text => {
    if(!text) { return ''; }
    if(typeof text === 'object'){ return moment(text).format('DD/MM/YYYY'); }
    return !text.startsWith('0001-01-01') ? moment(text).format('DD/MM/YYYY HH:mm:ss') : ''
  }

  static mask = text => {
    text = text.toString();
    return text ? text.substring(text.length / 2, text.length).padStart(text.length, '*') : '';
  }

  static parseFileSize = size => {
    if(size > 0){
      var i = Math.floor( Math.log(size) / Math.log(1024) );
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    }
    return size + 'B';
  }
}